import { PageType } from "@product/scmp-sdk";

import type { AppBarVariant } from "~/components/app-bar/helpers";
import type { Variant as SectionVariant } from "~/pages/section/enums";

export const pathname = "/sub-section";

export const page = {
  route(
    query: QueryParameters<{
      appBarVariant?: AppBarVariant;
      entityId: string;
      name?: string;
      parentSection?: string;
      relatedSectionsQueueName?: string;
      sectionVariant?: SectionVariant;
    }>,
  ) {
    return {
      pathname,
      query: { ...query, pageType: PageType.SubSection },
    };
  },
};
